import React, { useEffect } from 'react';
import './HomePage.css';
import HeroSection from './sections/HeroSection';
import AboutSection from './sections/AboutSection';
import StripsSection from './sections/StripsSection';
import CaptureSection from './sections/CaptureSection';
import ReelsSection from './sections/ReelsSection';
import FooterSection from './sections/FooterSection';

const HomePage = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="home_page_container">
      <HeroSection />
      <AboutSection />
      <StripsSection />
      <CaptureSection />
      <ReelsSection />
      <FooterSection />
    </div>
  );
};

export default HomePage;
